export const KeySetKeys = Object.freeze({
  REGISTER: 'REGISTER',
  LOGIN: 'LOGIN',
  SEARCH: 'SEARCH',
  TUNER: 'TUNER',
  REDEEM: 'REDEEM',
  SETTINGS: 'SETTINGS',
  VOLUMESLIDER: 'VOLUMESLIDER',
  NOWPLAYING: 'NOWPLAYING',
  TUNER_SCRUBBER: 'TUNER_SCRUBBER',
  MODAL: 'MODAL',
  AUTOCOMPLETE: 'AUTOCOMPLETE',
} as const);

export const MousetrapKeys = Object.freeze({
  ENTER: 'enter',
  SPACE: 'space',
  RIGHT: 'right',
  LEFT: 'left',
  UP: 'up',
  DOWN: 'down',
  SHIFT_UP: 'shift+up',
  SHIFT_DOWN: 'shift+down',
  ALT_UP: 'alt+up',
  ALT_DOWN: 'alt+down',
  MINUS: '-',
  PLUS: '+',
  ESC: 'esc',
  TAB: 'tab',
  SHIFT_TAB: 'shift+tab',
} as const);

export const KeyCodes = Object.freeze({
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CONTROL: 17,
  ALT: 18,
  CAPSLOCK: 20,
  ESC: 27,
  SPACE: 32,
  LEFT_ARROW: 37,
  UP_ARROW_KEY: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW_KEY: 40,
  COMMAND: 91,
  LEFT_COMMAND: 91,
  RIGHT_COMMAND: 93,
  FIREFOX_COMMAND: 224,
  PERIOD: 46,
} as const);
